
<div class="app-container">
    
    <app-notification-banner></app-notification-banner>

    <ng-container *ngIf="hasNavBar">
        <nav class="navbar navbar-expand-lg bg-body-tertiary">
            <ng-container *ngTemplateOutlet="navTpl"></ng-container>
        </nav>
    </ng-container>

    <div class="mainContent">
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </div>

    <ng-container *ngIf="hasFooter">
        <footer class="footer">            
            <ng-container *ngTemplateOutlet="footerTpl"></ng-container>            
        </footer>
    </ng-container>
</div>